import { render, staticRenderFns } from "./productDetailUploadStandard.vue?vue&type=template&id=a3ad5d14&scoped=true"
import script from "./productDetailUploadStandard.vue?vue&type=script&lang=js"
export * from "./productDetailUploadStandard.vue?vue&type=script&lang=js"
import style0 from "./productDetailUploadStandard.vue?vue&type=style&index=0&id=a3ad5d14&prod&scoped=true&lang=css"
import style1 from "./productDetailUploadStandard.vue?vue&type=style&index=1&id=a3ad5d14&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3ad5d14",
  null
  
)

export default component.exports